import classnames from 'classnames';
import { generateMonth } from 'components/DateRangePicker/generateCalendar';
import { startOfWeekLocale } from 'components/DateRangePicker/mondayBasedLocales';
import Week from 'components/Week';
import addDays from 'date-fns/addDays';
import isSunday from 'date-fns/isSunday';
import React from 'react';
import formatDate from 'utils/formatDate';

const CSS = require('./Month.less');

const startOfWeekDay = startOfWeekLocale(new Date());

interface MonthProps {
  month: Date;
  onSelect: (e: Date) => void;
  startDate: Date;
  endDate: Date;
  showDayHeader?: boolean;
  availableDays?: Map<string, boolean>;
  markedDays?: Map<string, boolean>;
  className?: string;
}

const Month = ({
  month,
  onSelect,
  startDate,
  endDate,
  className,
  availableDays,
  showDayHeader,
  markedDays,
}: MonthProps) => {
  const weeks = generateMonth(
    month.getFullYear(),
    month.getMonth() + 1,
    isSunday(startOfWeekLocale(month)),
  );
  return (
    <div className={classnames(CSS.Month, { [className]: className })}>
      <div className={CSS.Header}>
        <div
          className={classnames(CSS.MonthName, {
            [CSS.MonthNamePushDown]: showDayHeader,
          })}
        >
          {formatDate(month, 'MMMM yyyy')}
        </div>
        {showDayHeader && (
          <div className={CSS.DayNames}>
            <span className={CSS.dayHeaderDay}>
              {formatDate(startOfWeekDay, 'EE')}
            </span>
            <span className={CSS.dayHeaderDay}>
              {formatDate(addDays(startOfWeekDay, 1), 'EE')}
            </span>
            <span className={CSS.dayHeaderDay}>
              {formatDate(addDays(startOfWeekDay, 2), 'EE')}
            </span>
            <span className={CSS.dayHeaderDay}>
              {formatDate(addDays(startOfWeekDay, 3), 'EE')}
            </span>
            <span className={CSS.dayHeaderDay}>
              {formatDate(addDays(startOfWeekDay, 4), 'EE')}
            </span>
            <span className={CSS.dayHeaderDay}>
              {formatDate(addDays(startOfWeekDay, 5), 'EE')}
            </span>
            <span className={CSS.dayHeaderDay}>
              {formatDate(addDays(startOfWeekDay, 6), 'EE')}
            </span>
          </div>
        )}
      </div>
      {weeks.map((days, weekIndex) => {
        const key = `${month.getFullYear()}-${month.getMonth()}-${weekIndex}`;
        return (
          <Week
            startDate={startDate}
            endDate={endDate}
            key={key}
            parentKey={key}
            days={days}
            month={month}
            onSelect={onSelect}
            availableDays={availableDays}
            markedDays={markedDays}
          />
        );
      })}
    </div>
  );
};

export default Month;
